import dayjsEsm from 'dayjs/esm'
import 'dayjs/esm/locale/de'

import relativeTime from 'dayjs/esm/plugin/relativeTime'
import updateLocale from 'dayjs/esm/plugin/updateLocale'
import timezone from 'dayjs/esm/plugin/timezone'
import utc from 'dayjs/esm/plugin/utc'
import isSameOrAfter from 'dayjs/esm/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/esm/plugin/isSameOrBefore'
import isBetween from 'dayjs/esm/plugin/isBetween'
import quarterOfYear from 'dayjs/esm/plugin/quarterOfYear'
import weekOfYear from 'dayjs/esm/plugin/weekOfYear'
import duration from 'dayjs/esm/plugin/duration'
import advancedFormat from 'dayjs/esm/plugin/advancedFormat'

// custom plugins
import range from './range'
import roundNearest from './roundNearest'
import twoYears from './twoYears'

declare global {
  interface Window {
    dayjs: typeof dayjsEsm
  }
}
window.dayjs = dayjsEsm

// base
dayjsEsm.extend(relativeTime)

// locale
dayjsEsm.extend(updateLocale)
dayjsEsm.updateLocale('de', {})
dayjsEsm.locale('de')

// timezone
dayjsEsm.extend(utc)
dayjsEsm.extend(timezone)
dayjsEsm.tz.setDefault('')

// utility
dayjsEsm.extend(isSameOrAfter)
dayjsEsm.extend(isSameOrBefore)
dayjsEsm.extend(isBetween)
dayjsEsm.extend(quarterOfYear)
dayjsEsm.extend(weekOfYear)
dayjsEsm.extend(duration)
dayjsEsm.extend(advancedFormat)

// custom
dayjsEsm.extend(roundNearest)
dayjsEsm.extend(twoYears)
dayjsEsm.extend(range)

const dayjs = dayjsEsm
export default dayjs
